export default "__VITE_ASSET__2ee0c05e__"